/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/* eslint-disable */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ReactMarkdown from 'react-markdown';
import {
    shape, string, bool, object, arrayOf, func,
} from 'prop-types';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';

// Material UI
import Button from '@material-ui/core/Button';
import { Grid } from '@material-ui/core';

// Helpers
import Helper from '../../../state/reducers/Helper';
import { format } from 'date-fns';
import { isEmpty } from '../../../utils/object';
import { formatPrice } from '../../../utils/formater';
import { secureProtocol } from '../../../utils/secureProtocol';
import { getCryptedOrderDetailsURL } from '../../../utils/crypto'
import { getFeatureFlags } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

// Components
import Image from '../../../common/Image';
import ReplacementOrderModal from '../SelfService/Desktop/ReplacementOrderModal';
import ReplacementOrderV2Modal from '../SelfService/Desktop/ReplacementOrderV2Modal';
import ReplacementOrderV3Modal from '../SelfService/Desktop/ReplacementOrderV3Modal';
import CancelOrderModal from '../SelfService/Desktop/CancelOrderModal';
import brandNames from '../../../assets/data/BrandNames';
import ProductLink from '../../../common/ProductLink';
import OrderTracking from './OrderTracking';

const ProductDetails = ({ ROSSOrder, ...props }) => {
   const featureFlags = useSelector(getFeatureFlags);
   const isROSSItemStatusEnabled = featureFlags['is-ross-item-status-enabled'];

    const [Csi, setCsi] = useState({
        openCancelModal: false,
        CSITime: '',
        openReportAnIssueModal: false
    });

    const handleChangeModalState = async (buttonValue, closeWindow, openChat) => {
        const { history, handleRedirectToLogin, loginByRedirect } = props;
        let redirectToLogin = false;

        const isKMSIEnabled = featureFlags?.['is-keep-me-signed-in-redirect-enabled'] || false;
        if (isKMSIEnabled) {
            // Handle redirect to login if login required on click of cancel order button
            redirectToLogin = await handleRedirectToLogin(featureFlags, loginByRedirect);
        }

        if (!redirectToLogin) {
            let incidentCreationTime = '';
            if (buttonValue === 'cancel' && !Csi.openCancelModal) {
                const date = new Date();
                incidentCreationTime = `${format(date, 'yyyy-MM-dd')}T${format(date, 'kk:mm:ss.SSS')}Z`; // https://date-fns.org/v2.7.0/docs/format
                setCsi({
                    ...Csi,
                    openCancelModal: true,
                    CSITime: incidentCreationTime,
                });
            }
            if (buttonValue === 'replacement' && !Csi.openReportAnIssueModal) {
                const date = new Date();
                incidentCreationTime = `${format(date, 'yyyy-MM-dd')}T${format(date, 'kk:mm:ss.SSS')}Z`; // https://date-fns.org/v2.7.0/docs/format
                setCsi({
                    ...Csi,
                    openReportAnIssueModal: true,
                    CSITime: incidentCreationTime,
                });
                return;
            }
            if (closeWindow === 'closeWindow') {
                let stateToChange = '';
                if (buttonValue === 'replacement') stateToChange = 'openReportAnIssueModal';
                else if (buttonValue === 'cancel') stateToChange = 'openCancelModal';
                setCsi({
                    [stateToChange]: false,
                    }, () => {
                        if (closeWindow === 'closeWindow' && !openChat) {
                            history.go();
                        }
                    });
            }
        }
    }

    const productDetail = (
        key,
        isLastItem,
        ROSSItem,
        isAddOn,
    ) => {
        const {
            isMultiItemOrder, intOrderNumber, ROSSOrderNumber, isROSSPassport, ROSSOrderReplacementFlag,
            ROSSOrderPartialCreditFlag, ROSSCSIFailureReason, isDonationItem, showSubStatus, showCarrier, renderTrackingLink, showDelivered,
            history, brandID,isShowingTrackingWidget, isOrderContainsFoodProduct, ROSSOrderTotal,
        } = props;

        const productBrandCode = ROSSItem?.productBrand;

        const isCancelReasonEnabled = featureFlags['is-cancel-reason-enabled'];
        const isPartialCreditEnabled = featureFlags['is-partial-credit-enabled'];
        const isReplacementEnabled = featureFlags['is-ross-replacement-web-on'];
        const IsPendingCancelEnabled = featureFlags['is-pending-cancel-enabled'];
        const isHidingCardIsleImage = featureFlags['is-hiding-cardisle-image'];
        const isWebCancelEnabled = featureFlags['is-web-cancel-enabled']; // Flag responsible to turn on/off Cancel functionality(line item cancel & whole order cancel both)
        const isCancelByItemVariantEnabled = featureFlags['which-cancel-by-line-item-variant'][productBrandCode]; // This flag is responsible to check line item cancel turned on/off per product brand
        const isReplacementV2Enabled = featureFlags['is-replacement-v-2-enabled'];
        const isReplacementV1Enabled = featureFlags['is-replacement-v-1-enabled'];
        const isReplacementTestingOn = featureFlags['is-replacement-testing-on'];
        const isCancelRefundAmountDisplayed = featureFlags['is-cancel-refund-amount-displayed'];
        const isOnclickCallGraphql = featureFlags?.['is-onclick-call-graphql'];
        const HDDeliveredStatusBypass = featureFlags['is-hd-delivered-status-bypass-enabled']; // TEST ONLY FLAG - DO NOT ENABLE IN PRODUCTION
        const isReplacementEnabledForBrand = featureFlags['is-replacement-variant-flag-on'][productBrandCode];
        const isReplacementOrderV3Enabled = featureFlags['refund-and-replacement-modal-variant'] === 'control';

        const totalPriceWithTax = ROSSOrder?.billingProfile?.totalCharge;
        const tiEmail = ROSSOrder?.billingProfile?.emailAddress
        const doesItemTrackingNumberMatchOrderTrackingNumber = (ROSSItem?.trackingNumber === ROSSOrder?.trackingNumber);
        const isFPTOrderDelayedOrHasStatusUpdate = (ROSSItem?.itemType === 'FPT' && (ROSSOrder?.history?.[0]?.attemptedReason || ROSSOrder?.history?.[0]?.statusDescription));
        const allowCancelInsideReplacementModal = ROSSOrder?.cancelFlag === 'Y' && ROSSOrder?.deliveryStatus === 'W' && !isROSSPassport && !isDonationItem; // to allow cancel product from v2 replacement modal
        const isOrderReservebar = ROSSOrder?.source === 'RBAR';
        const noDLCF = (featureFlags['is-replacement-nodlcf-on'] && ROSSOrder?.noDLCF) || false;
        const replacementAlreadyIssued = ROSSOrder?.repCount > 0 && !ROSSOrder.parentOrderNumber;
        const replacementOrderNumber = ROSSOrder?.repOdrNumbers;
        const isFOMCChildItemTypeA = (ROSSOrder?.items?.[0]?.subItemType === '3' && ROSSItem?.subItemType === 'A');
        const distCharges = ROSSOrder?.billingProfile?.distCharges?.charges;
        const isCAABTestActive = distCharges?.some((charge) => charge?.distChrgType === 'DCH' && Number(charge.distAmt) > 0);
        const CaTestMerchPrice = isCAABTestActive ? distCharges?.find((charge) => charge?.distChrgType === 'BCH')?.distAmt : '';
        const itemPrice = isCAABTestActive ? formatPrice(Number(ROSSItem.price) + Number(CaTestMerchPrice)) : formatPrice(Number(ROSSItem.price));

        const fallbackImgURL = 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltc881f4b32ef5f484/60dcd2de4b10c259bbae6426/Image_Not_Available.png';
        let ROSSProductImageURL = ROSSItem?.prdImgTmn && ROSSItem?.prdImgTmn !== '' ? secureProtocol(ROSSItem?.prdImgTmn) : fallbackImgURL;
        if (isHidingCardIsleImage && Helper.isDeliveredCardIsle(ROSSItem)) {
            ROSSProductImageURL = fallbackImgURL;
        }

        let ROSSItemWithOrderAttributes = {};
        // Creating a Ross Item with logical order level attributes to display status on ross item level
        if (isROSSItemStatusEnabled) {
            ROSSItemWithOrderAttributes = {
                ...ROSSItem,
                // Children of CYO/PYO/CLUB do not have status and deliveryStatus fields so we have to do a null check when order loads from checkout
                status: ROSSItem?.status ? ROSSItem.status : 'CONFIRMED',
                deliveryStatus: ROSSItem?.deliveryStatus ? ROSSItem.deliveryStatus : 'W',
                type: ROSSItem?.itemType,
                history: ROSSOrder?.history || [],
                // Pending cancel is done on the order level, so we can use ROSS order value. If we want to support cancel by item, we'll have to add a condition
                pendingCancel: ROSSOrder?.pendingCancel,
                // We're waiting on BE to populate items wih pendingUpdate field
                pendingUpdate: ROSSOrder?.pendingUpdate,
                // ROSS adds a status description field to the order level based on the history object and tracking information from the first item in the array
                //  - If there are multiple items in the array that shipped separately, we don't want to display status description for items whose tracking number does not match the order level tracking number
                //  - If the item is FPT delivered by florist, it will not have a tracking number, so we have to check if it has an attempted reason or a status description in order to display the status description
                statusDescription: doesItemTrackingNumberMatchOrderTrackingNumber || isFPTOrderDelayedOrHasStatusUpdate ? ROSSOrder?.statusDescription : '',
                attemptedReason: isFPTOrderDelayedOrHasStatusUpdate ? ROSSOrder?.attemptedReason : '',
            };
        }

        const isReportAnIssueEnabled = (
            isReplacementV1Enabled
            && featureFlags['is-replacement-variant-flag-on'][productBrandCode]
            && (isReplacementEnabled || isPartialCreditEnabled)
            && (ROSSOrderPartialCreditFlag || ROSSOrderReplacementFlag)
            && !isMultiItemOrder
            && !isEmpty(ROSSOrder)
            && ROSSOrder?.deliveryStatus === 'D'
            && !isROSSPassport
            && !isDonationItem
            && ROSSOrder?.repCount === '0'
            && ROSSOrder?.repFound === 'N'
            && ROSSOrder?.repAllowed === 'Y'
        );
        
        const isReportAnIssueV2Enabled = (
            isReplacementV2Enabled
            &&  (!isReplacementOrderV3Enabled || (isReplacementOrderV3Enabled && key === 0)) // to not show refund and replacement button for all items in the order
            && isReplacementEnabledForBrand
            && (isReplacementTestingOn // TEST ONLY FLAG - DO NOT ENABLE IN PRODUCTION
            || noDLCF
            || (!isMultiItemOrder
            && !isEmpty(ROSSOrder)
            && !isROSSPassport
            && !isDonationItem
            && ROSSOrder?.repCount === '0'
            && ROSSOrder?.repFound === 'N'
            && ROSSOrder?.repAllowed === 'Y'
            && (ROSSOrderPartialCreditFlag || ROSSOrderReplacementFlag || HDDeliveredStatusBypass))) // TEST ONLY FLAG - DO NOT ENABLE IN PRODUCTION
        );


        const isCancelByLogicalOrdersEnabled = (
            isWebCancelEnabled
            && isCancelByItemVariantEnabled
            && ROSSOrder?.cancelFlag === 'Y'
            && ROSSOrder?.deliveryStatus === 'W'
            && !isAddOn
            && !isDonationItem
            && !isOrderContainsFoodProduct
        );

        // Determines which Replacement Order Modal to render based on the feature flag:
        // 'control' -> Renders ReplacementOrderV3Modal
        // 'variant' -> Renders ReplacementOrderV2Modal
        // To completely disable ReplacementOrderVariantModal, set the feature flag 'is-replacement-v-2-enabled' to 'off'

        const ReplacementOrderVariantModal = isReplacementOrderV3Enabled ? ReplacementOrderV3Modal : ReplacementOrderV2Modal;

        return (
            <>
                {isROSSItemStatusEnabled && isShowingTrackingWidget(ROSSItem, ROSSOrder) && (
                <>
                <div className="orderDetail-tracker-flex-column-start">
                    <OrderTracking                                        
                        ROSSOrderPendingCancel={ROSSItemWithOrderAttributes?.pendingCancel}
                        ROSSStatus={showDelivered ? 'DELIVERED' : ROSSItemWithOrderAttributes?.status}
                        IsPendingCancelEnabled={IsPendingCancelEnabled}
                    />
                    <div>
                        {showSubStatus(ROSSItemWithOrderAttributes)}
                    </div>
                    {ROSSItemWithOrderAttributes?.itemType === 'FPT' && (
                        <div className="order-info order-details">
                            <span className="uppercase gray-color bold">Delivered By: </span>
                            <span>Local Shop</span>
                        </div>
                    )}
                    {ROSSItemWithOrderAttributes?.itemType === 'GPT' && (
                        <div className="order-info" style={{ marginTop: '0px'}}>
                            {ROSSItemWithOrderAttributes.carrier && (
                                <div className="order-delivered" style={{ marginBottom: '0px' }}>
                                    <span className="uppercase gray-color bold">Delivered By: </span>
                                    {showCarrier(ROSSItemWithOrderAttributes?.carrier)}
                                </div>
                            )}
                            {!isROSSPassport && (ROSSItemWithOrderAttributes?.status !== 'CANCELLED') && !isDonationItem && (
                                <div className="order-track">
                                    <span className="uppercase gray-color bold">Tracking: </span>
                                    <span className="bold">{ROSSItemWithOrderAttributes.trackingNumber
                                        ? renderTrackingLink(ROSSItemWithOrderAttributes.carrier, ROSSItemWithOrderAttributes.trackingNumber, ROSSItemWithOrderAttributes.deliveryLink, ROSSItem?.productBrand) : 'Available Once Shipped'}
                                    </span>
                                </div>
                            )}
                        </div>
                    )}         
                    </div>
                </>
                )}
                <div
                    key={key}
                    className={`split product-detail margin-bottom ${isLastItem ? 'last' : ''
                    }`}
                >
                    {!isEmpty(ROSSItem) && (
                        <div className="product-image">
                            <Image src={ROSSProductImageURL} alt={ROSSItem.productName} />
                            <div className="name-sku-container">
                                <div className="product-name">
                                    {isOnclickCallGraphql && !isFOMCChildItemTypeA
                                        ? (
                                            <ProductLink
                                                brandID={brandID}
                                                productSku={ROSSItem.productSku}
                                                productName={ROSSItem.productName}
                                                history={history}
                                                productBrand={ROSSItem.productBrand}
                                            />
                                        )
                                        : (
                                            !isFOMCChildItemTypeA ? (
                                                <Link to={ROSSItem?.seoUrl || `/searchterm/${ROSSItem.productSku}`}><ReactMarkdown children={ROSSItem.productName} /></Link>
                                            ) : (
                                                <ReactMarkdown children={ROSSItem.productName} />
                                            )
                                    )}
                            </div>
                            <div>{brandNames[productBrandCode]}</div>
                            <div className="gray-color">
                                Item #: {ROSSItem.productSku}
                            </div>
                            {isROSSItemStatusEnabled &&
                                <div style={{ paddingBottom: '12px' }}>
                                    {Number(itemPrice) !== 0 &&
                                    <div>
                                        <span className="-price-label">Price: </span>
                                        ${formatPrice(itemPrice)}
                                    </div>
                                    }
                                    <div>
                                        <span className="-price-label">Qty: </span>
                                        {ROSSItem.quantity}
                                    </div>
                                </div>
                            }
                            </div>
                        </div>
                    )}
                    <div className="product-description price-qty-bottom">
                        {replacementAlreadyIssued && (
                            <div className="bold replacement-already-found-container">
                                {replacementOrderNumber ? (
                                    <div>
                                        <p>Replacement Order Tracking:</p>
                                        <div
                                        style={{ color: '#4A90E2', textDecoration: 'underline', fontWeight: 500 }}
                                        role="link"
                                        tabIndex="0"
                                        onClick={() => {
                                            const ordersURL = getCryptedOrderDetailsURL(replacementOrderNumber);
                                            history.push(ordersURL);
                                        }}
                                        >
                                        {replacementOrderNumber}
                                        </div>
                                    </div>
                                ) : (
                                    <p>Replacement Issued</p>
                                )}
                            </div>
                        )}
                        {isReportAnIssueEnabled && (
                            <>
                                <Button
                                    variant="container"
                                    onClick={() => handleChangeModalState('replacement')}
                                    onKeyDown={handleChangeModalState}
                                    className="replace-button"
                                    style={{ textTransform: 'none', whiteSpace: 'nowrap' }}
                                >
                                    Report an Issue
                                </Button>
                                {
                                    Csi.openReportAnIssueModal
                                        ? (
                                            <ReplacementOrderModal
                                                handleChangeModalState={handleChangeModalState}
                                                ROSSOrder={ROSSOrder}
                                                productType={ROSSItem?.itemType}
                                                startTime={isCsiOpen.CSITime}
                                                ROSSOrderNumber={ROSSOrderNumber}
                                                isPartialCreditEnabled={isPartialCreditEnabled}
                                                isReplacementEnabled={isReplacementEnabled}
                                                ROSSOrderPartialCreditFlag={ROSSOrderPartialCreditFlag}
                                                ROSSOrderReplacementFlag={ROSSOrderReplacementFlag}
                                                ROSSCSIFailureReason={ROSSCSIFailureReason}
                                            />
                                        )
                                        : null
                                }
                            </>
                        )}
                        {
                            isCancelByLogicalOrdersEnabled && (
                                <>
                                    <Button
                                        variant="container"
                                        onClick={() => handleChangeModalState('cancel')}
                                        className="cancel-button"
                                        style={{ textTransform: 'none', whiteSpace: 'nowrap', display: 'none' }}
                                    >
                                        Cancel Item
                                    </Button>
                                    {
                                        Csi.openCancelModal
                                            ? (
                                                <CancelOrderModal
                                                    handleChangeModalState={handleChangeModalState}
                                                    orderNumber={ROSSOrder?.orderNumber}
                                                    intOrderNumber={intOrderNumber}
                                                    isCancelReasonEnabled={isCancelReasonEnabled}
                                                    totalCharge={ROSSOrder?.billingProfile.totalCharge}
                                                    tiEmail={tiEmail}
                                                    isCancelByItemVariantEnabled={isCancelByItemVariantEnabled}
                                                    totalPriceWithTax={totalPriceWithTax}
                                                    isCancelRefundAmountDisplayed={isCancelRefundAmountDisplayed}
                                                />
                                            )
                                            : null
                                    }
                                </>
                            )
                        }
                        {!isROSSItemStatusEnabled && 
                            <div className="split align-bottom float-right">
                                {!isEmpty(ROSSItem) && (
                                    <div className={isROSSPassport ? 'flex-none padding-top' : 'flex-none'}>
                                        <div>
                                            <span className="-price-label">Price: </span>$
                                            {formatPrice(itemPrice)}
                                        </div>
                                        <div className={isROSSPassport ? 'display-none' : ''}>
                                            <span className="-price-label">Qty: </span>
                                            {ROSSItem.quantity}
                                        </div>
                                    </div>
                                )}
                            </div>
                        }
                    </div>
                </div>
                {isOrderReservebar &&
                  <Grid className='mobile-reservebar-contact-info'>
                     <Grid item>
                        Issues with this item, please email
                     </Grid>
                     <Grid item>
                        <a href={`mailto:customerhelp@reservebar.com`}>customerhelp@reservebar.com</a>
                        {' '}or call{' '}
                        <a href={`tel:18443685160`}>1-844-368-5160</a>
                     </Grid>
                  </Grid>
                }
                {isReportAnIssueV2Enabled && (
                    <Grid className="replacement-v2-container">
                        {isReplacementOrderV3Enabled ?
                            <div style={{ fontSize: '14px', lineHeight: '20px', letterSpacing: '0.07px' }}>
                                Need help? <span
                                    style={{ color: '#1F6CC6', textDecoration: 'underline', cursor: 'pointer' }}
                                    onClick={() => {
                                        handleChangeModalState('replacement');
                                    }}>Report an issue</span>
                            </div>
                            :
                            <Button
                                variant="container"
                                onClick={() => {
                                    handleChangeModalState('replacement')
                                }}
                                className="replacement-v2-cta-button"
                                style={{ textTransform: 'none' }}
                            >
                                Get a refund or replacement
                            </Button>
                        }
                        {
                        Csi.openReportAnIssueModal
                            ? (
                                <ReplacementOrderVariantModal
                                    handleChangeModalState={handleChangeModalState}
                                    ROSSOrder={ROSSOrder}
                                    productType={ROSSOrder?.items?.[0]?.itemType}
                                    startTime={Csi.CSITime}
                                    ROSSOrderNumber={ROSSOrderNumber}
                                    isPartialCreditEnabled={isPartialCreditEnabled}
                                    isReplacementEnabled={isReplacementEnabled}
                                    allowCancel={allowCancelInsideReplacementModal}
                                    tiEmail={tiEmail}
                                    ROSSOrderTotal={ROSSOrderTotal}
                                    noDLCF={noDLCF}
                                />
                            )
                            : null
                        }
                    </Grid>
                )}
            </>
        );
    }

    if (!isEmpty(ROSSOrder)) {
        let isCollectionParent = false;
        let isClubParent = false;
        if (ROSSOrder.items.findIndex((item, index) => item.addonType === 'COL_PARENT' && item.subItemType === '4' && index === 0) !== -1) isCollectionParent = true;
        if (ROSSOrder.items.findIndex((item, index) => item.addonType === 'CLUB_PAR' && item.subItemType === '4' && index === 0) !== -1) isClubParent = true;
        return ROSSOrder.items.map((ROSSProduct, key) => {
                let isAddOn = false;
                let isCollectionChild = false;
                let isClubChild = false;
                if (ROSSProduct.addonType === 'ADDON' || ROSSProduct.addonType === 'GCI') isAddOn = true;
                if (ROSSProduct.subItemType === 'A') isCollectionChild = true;
                if (isCollectionParent && ROSSProduct.subItemType === 'A') isCollectionChild = true;
                if (isClubParent && ROSSProduct.subItemType === 'A') isClubChild = true;
                if ((isCollectionParent && isCollectionChild) || (isROSSItemStatusEnabled && isClubParent && isClubChild)) return null;
                if (!ROSSProduct?.displayed) return null;
                return (
                    productDetail(
                        key,
                        ROSSOrder.items.length - 1 === key,
                        ROSSProduct,
                        isAddOn,
                    )
                );
        });
    }

   return null;
}

ProductDetails.defaultProps = {
    ROSSOrder: {},
    featureFlags: {},
    ROSSOrderNumber: '',
    history: {},
    isROSSPassport: false,
    isDonationItem: false,
};

ProductDetails.propTypes = {
    ROSSOrder: shape({
        brandId: string,
        modifiedDateTime: string,
        orderNumber: string,
        orders: arrayOf(shape({
            actualDeliveryDate: string,
            address: string,
            carrier: string,
            courier: string,
            createdDate: string,
            currentLocation: object,
            deliveryDate: string,
            deliveryImageURL: string,
            deliveryMethod: string,
            deliveryNotes: string,
            history: arrayOf(shape({
                codeStatus: string,
                createdDate: string,
                location: object,
                status: string,
                statusDescription: string,
            })),
            intOrderNumber: string,
        })),
        items: arrayOf(shape({
            productBrand: string,
            itemType: string,
            productName: string,
            productSku: string,
        })),
        origin: string,
        recipientFirstName: string,
        recipientLastName: string,
        signatureImageURL: string,
        status: string,
        statusDescription: string,
        trackingNumber: string,
        type: string,
        warningMessage: string,
    }),
    featureFlags: object,
    isMultiItemOrder: bool.isRequired,
    intOrderNumber: string.isRequired,
    ROSSOrderNumber: string,
    history: shape({
        go: func.isRequired,
    }),
    isROSSPassport: bool,
    isDonationItem: bool,
    brandID: string.isRequired,
    ROSSCSIFailureReason: object.isRequired,
    showDelivered: bool.isRequired,
    isShowingTrackingWidget: func.isRequired,
    isOrderContainsFoodProduct: bool.isRequired,
};

export default withRouter(ProductDetails);
